export default __webpack_public_path__ + "static/media/charles_kimani.76feb0b7.jpg";